
	export default {
		props: {
			numberProp: {
				type: String,
				default: ''
			},
			limit: {
				type: Number,
				default: 20
			},
			decimal: {
				type: Boolean,
				default: false
			}
		},
		data () {
			return {
				number: this.numberProp,
				numPad: [
					[1, 2, 3],
					[4, 5, 6],
					[7, 8, 9],
					this.decimal ? [0, '.', 'C'] : [0, 'C', 'CLEAR']
				]
			}
		},
		watch: {
			numberProp (number) {
				this.number = number
			}
		},
		methods: {
			appendNumber (number) {
				this.$emit('update:number', number)
			}
		}
	}
